export default __webpack_public_path__ + "static/media/4-cassettes-open-1-left.7b00c51f.svg";